import styles from './index.module.scss'
import { useMediaQuery } from 'react-responsive';

const Card1 = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
   return (
     <div className='w-1340'>
       <div className={`flex ${styles.card} flex-just flex-wrap`}>
         {
           isMobile?(
             <div className={`flex ${styles.boxContent}`}>
               For parties seeking to retain full control of their assets, Vishwa delivers trustless access to
               orchestrated lending and yield markets.<br/>
               Regardless of which public chain their native assets are minted on, users remain in full self-custody, with liquidity and yield unlocked directly through ZK Proof-of-Assets—never intermediaries.
             </div>
           ): (
             <div className={`flex ${styles.boxContent}`}>
               For parties seeking to retain full control of their assets, Vishwa delivers trustless access to <br />
               orchestrated lending and yield markets.<br />
               Regardless of which public chain their native assets are minted on, users remain in full self-custody,
               with liquidity and yield unlocked directly through ZK Proof-of-Assets—never intermediaries.
             </div>
           )
         }

       </div>
     </div>

   )
}

export default Card1